import React from 'react';
import { motion } from 'framer-motion';
export function IdentityTransitionSection() {
  return <section className="bg-gradient-section px-5 md:px-8" data-id="element-352" data-mp="135h1rvor7j66">
      <div className="mx-auto max-w-2xl" data-id="element-353" data-mp="133w5o1msjs67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.9,
        delay: 0.2
      }} className="mt-20 md:mt-28 max-w-md mx-auto text-center" data-id="element-354" data-mp="y6cq8yecx9co">
          

          

          <p className="font-display font-semibold text-[#F0E8D8] leading-[1.2] mb-4" style={{
          fontSize: 'clamp(24px, 5.5vw, 36px)'
        }} data-id="element-355" data-mp="kdwnzzta5fct">
            No necesitás tener todo resuelto hoy.
          </p>
          <p className="font-display italic text-gradient-gold leading-[1.25]" style={{
          fontSize: 'clamp(20px, 5vw, 32px)'
        }} data-id="element-356" data-mp="af8hnyanqooy">
            Podés empezar con un plan claro<br data-id="element-357" data-mp="1h54bp9tsy88" />y avanzar a tu ritmo.
          </p>

          <div className="mx-auto mt-10 mb-7" style={{
          width: 48,
          height: '0.5px',
          background: 'rgba(200,168,112,0.35)'
        }} data-id="element-358" data-mp="cqa9035nvv3j" />
        </motion.div>
      </div>
    </section>;
}